module.exports = __webpack_public_path__ + "img/60_6.12b565bf.png";